<loader-view [show]="loader.view"></loader-view>
<!-- aqui me lleva el boton editar de acciones -->
<!-- tmb me lleva aqui el boton de guardar de las acciones -->
<!-- aqui en alguna parte esta el form-input-select de los bloqueo/des -->
<!-- 
  authorizedElement
  [authElementCode]="52594"
  [authElementName]="'PANEL_MARK_LIST_ADMINISTRATOR'" 
-->
<panel-add-row
  [show]="true"
  title="Estados"
  [(items)]="statusData"
  autoScrollContainer=".modal"
  [showDetele]="false"
  [noAdd]="true"
  [templateHeader]="templateHeaderGastos"
  [templateBody]="templateBodyGastos"
  (verifySave)="onSaveRequest($event)"
  (verifyDelete)="onDeleteStatus($event)"
  [(toSave)]="subscriber.onSaveStatus"
  [detail]="!editMode"
  (clickReload)="clickReload()"
  (onPressUpdate)="onPressUpdateRequest($event)"
  [(noEdit)]="noEditItem">
</panel-add-row>

<ng-template #templateHeaderGastos>
  <th class="cell-50">ID</th>
  <th class="text-center cell-300">Fecha de registro</th>
  <th class="text-center cell-100">Area</th>
  <th class="text-center cell-100">Subarea</th>
  <th class="text-center cell-250">Tipo de alerta</th>
  <th class="text-center cell-100">Tipo de registro</th>
  <th class="text-center cell-100">Usuario</th>
  <th class="text-center cell-100">Pais bloqueador</th>
  <th class="text-center cell-180">Estado</th>
  <th class="text-center cell-500">Sistema a bloquear</th>
  <th class="text-center cell-200">Observación</th>
</ng-template>

<ng-template
  #templateBodyGastos
  let-item="item"
  let-index="index"
  let-disabled="disabled">
  <td>{{ item.idStatusPerson }}</td>
  <td>{{ item.formattedRegisterDate }}</td>
  <td>{{ item.registrationArea }}</td>
  <td>{{ item.subArea }}</td>
  <td>{{ item.alertType }}</td>
  <td>{{ item.registerType }}</td>
  <td>{{ item.userNameRegister }}</td>
  <td>{{ item.countryBlocked }}</td>
  <td>
    <ng-container *ngIf="item.nameStatus != 'EN REVISION'; else revisionStatus">
      <form-input-select
        [onlySelect]="true"

        [model]="{ codigo: item.idStatus }"
        (modelChange)="onStatusChange($event, item)"
        [isValue]="false"
        [items]="idStatusList"
        fieldData=""
        fieldValue="nameStatus"
        idField="idStatus"
        [clearOnDestroy]="false"
        [disabled]="!item.isEdit">
      </form-input-select>
    </ng-container>
    <ng-template #revisionStatus>
      {{ item.nameStatus }}
    </ng-template>
  </td>
  <td>{{ item.systemBlocked }}</td>
  <td>{{ item.observation }}</td>
</ng-template>

<div style="padding: 1%" *ngIf="mostrarBtnAgregarRegistro">
  <!-- y este es el finalmente el otro boton de agregar registro -->
  <!-- este una especie de modal, que a lo sumo deberia cambiarle el texto -->
  <button
    authorizedElement
    [authElementCode]="19503"
    [authElementName]="'BTN_MARK_LIST_CHANGE_STATUS'"
    class="btn btn-info"
    (click)="toggleNewRegister()">
    {{ mostrarAgregarRegistro ? 'Ocultar' : 'Agregar Registro' }}
  </button>
</div>

<div class="row" *ngIf="mostrarAgregarRegistro">
  <div class="col-md-12">
    <h4>Agregar Registro de Estado</h4>

    <form
      [formGroup]="reactiveForm"
      (ngSubmit)="(submitForm)"
      class="smart-form">
      <fieldset>
        <div class="row">
          <dynamic-form
            class="form-registration"
            [formInputs]="dinamicFormInputsData"
            [suggestedNumberCols]="1"
            [templateInputsExternal]="{
              registrationArea: registrationAreaTemplate,
              subArea: subAreaTemplate,
              alertType: alertTypeTemplate,
              registerType: registerTypeTemplate,
              idStatus: idStatusTemplate,
              sistemaBloquear: sistemaBloquearTemplate,
              observation: observationTemplate
            }">
          </dynamic-form>

          <ng-template #registrationAreaTemplate>
            <div class="col-xs-12">
              <label class="label">Área</label>
              <label class="select">
                <select
                  class="formControl"
                  formControlName="registrationArea"
                  (click)="updateAreaDependingFields()">
                  <option *ngFor="let area of allAreas" [value]="area.cdOption">
                    {{ area.label }}
                  </option>
                </select>
                <i></i>
              </label>
              <div
                *ngIf="
                  reactiveForm.get('registrationArea').invalid &&
                  reactiveForm.get('registrationArea').touched
                ">
                <p class="error">El area registrante es obligatorio</p>
              </div>
            </div>
          </ng-template>

          <ng-template #subAreaTemplate>
            <div class="col-xs-12">
              <label class="label">Sub Área</label>
              <label class="select">
                <select
                  class="formControl"
                  formControlName="subArea"
                  (click)="getOptionSubArea()">
                  <option [ngValue]="null" disabled selected hidden>
                    Seleccione una opción
                  </option>
                  <option
                    *ngFor="let subArea of currentSubareas"
                    [value]="subArea.cdOption">
                    {{ subArea.label }}
                  </option>
                </select>
                <i>
                  <p class="text-center" *ngIf="isLoadingSubarea">
                    <img src="assets/img/loading2.gif" alt="" />
                  </p>
                </i>
              </label>
              <div
                *ngIf="
                  reactiveForm.get('subArea')?.invalid &&
                  (reactiveForm.get('subArea')?.touched ||
                    reactiveForm.get('subArea')?.dirty)
                ">
                <p class="error">El sub area es obligatorio</p>
              </div>
            </div>
          </ng-template>

          <ng-template #alertTypeTemplate>
            <div class="col-xs-12">
              <label class="label">Tipo de alerta</label>
              <label class="select">
                <select
                  class="formControl"
                  formControlName="alertType"
                  (click)="getOptionAlertType()">
                  <option [ngValue]="null" disabled selected hidden>
                    Seleccione una opción
                  </option>
                  <option
                    *ngFor="let alertType of currentAlertTypes"
                    [value]="alertType.cdOption">
                    {{ alertType.label }}
                  </option>
                </select>
                <i>
                  <p class="text-center" *ngIf="loadingImgAlertType">
                    <img src="assets/img/loading2.gif" alt="" />
                  </p>
                </i>
              </label>
              <div *ngIf="reactiveForm.value.alertType === 'Otro'">
                <div class="form-group">
                  <label class="label"> Motivo </label>
                  <input
                    class="form-control"
                    formControlName="motivo"
                    placeholder="Ingrese su motivo" />
                </div>
                <div
                  *ngIf="
                    reactiveForm.get('motivo')?.invalid &&
                    (reactiveForm.get('motivo')?.touched ||
                      reactiveForm.get('motivo')?.dirty)
                  ">
                  <p class="error">
                    El motivo no puede tener mas de 300 caracteres
                  </p>
                </div>
              </div>
              <div
                *ngIf="
                  reactiveForm.get('alertType')?.invalid &&
                  (reactiveForm.get('alertType')?.touched ||
                    reactiveForm.get('alertType')?.dirty)
                ">
                <p class="error">El tipo de alerta es obligatorio</p>
              </div>
            </div>
          </ng-template>

          <ng-template #registerTypeTemplate>
            <div class="col-xs-12">
              <label class="label">Tipo de registro</label>
              <label class="select">
                <select
                  class="formControl"
                  formControlName="registerType"
                  disabled>
                  <option [ngValue]="null" disabled selected hidden>
                    Seleccione una opción
                  </option>
                  <option
                    *ngFor="let registerType of currentRegisterType"
                    [value]="registerType.cdOption">
                    {{ registerType.label }}
                  </option>
                </select>
                <i>
                  <p class="text-center" *ngIf="loadingImgRegisterType">
                    <img src="assets/img/loading2.gif" alt="" />
                  </p>
                </i>
                <div
                  *ngIf="
                    reactiveForm.get('registerType')?.invalid &&
                    (reactiveForm.get('registerType')?.touched ||
                      reactiveForm.get('registerType')?.dirty)
                  ">
                  <p class="error">El tipo de registro es obligatorio</p>
                </div>
              </label>
            </div>
          </ng-template>

          <ng-template #idStatusTemplate>
            <div class="col-xs-12">
              <label class="label">Estados </label>
              <label class="select">
                <select class="formControl" formControlName="idStatus">
                  <option
                    *ngFor="let status of idStatusListCopy"
                    [value]="status.idStatus">
                    {{ status.nameStatus }}
                  </option>
                </select>
                <i></i>
              </label>
              <div
                *ngIf="
                  reactiveForm.get('idStatus').invalid &&
                  reactiveForm.get('idStatus').touched
                ">
                <p class="error">El estado es obligatorio</p>
              </div>
            </div>
          </ng-template>

          <ng-template #sistemaBloquearTemplate>
            <div class="col-xs-12">
              <label class="label">Sistema a Bloquear</label>
              <div class="checkbox-group">
                <div
                  *ngFor="let sistemaBloquear of sistemasBloquear"
                  class="checkbox-item">
                  <label>
                    <input
                      type="checkbox"
                      [value]="sistemaBloquear.cdOption"
                      (change)="onCheckboxChange($event, sistemaBloquear.cdOption)"
                      [checked]="reactiveForm.get('sistemaBloquear').value?.includes(sistemaBloquear.cdOption)" />
                    {{ sistemaBloquear.label }}
                  </label>
                </div>
              </div>
              <div
                *ngIf="
                  reactiveForm.get('sistemaBloquear').invalid &&
                  reactiveForm.get('sistemaBloquear').touched
                ">
                <p class="error">El sistema a bloquear es obligatorio</p>
              </div>
            </div>
          </ng-template>

          <ng-template #observationTemplate>
            <div class="col-xs-12">
              <div class="form-group">
                <label class="label"> Observación </label>
                <input class="form-control" formControlName="observation" />
              </div>
            </div>
            <div
              *ngIf="
                reactiveForm.get('observation').invalid &&
                reactiveForm.get('observation').touched
              ">
              <p class="error">
                La observación no puede tener mas de 300 caracteres
              </p>
            </div>
          </ng-template>

          <div class="col-xs-12 col-md-6">
            <div class="col-md-2 pull-right" *ngIf="loadingImg">
              <p class="text-center">
                <img src="assets/img/loading2.gif" alt="" /> Cargando ...
              </p>
            </div>
          </div>
        </div>
      </fieldset>
      <button
        class="btn btn-info"
        [disabled]="reactiveForm.invalid"
        (click)="submitForm()">
        Ingresar Solicitud
      </button>
    </form>
  </div>
</div>
<div
  class="modal-dialog modal-xs modal-centered"
  *ngIf="showCommentModal"
  style="
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1050;
  ">
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="close"
        (click)="closeModal()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">Confirmación</h4>
    </div>
    <div class="modal-body overflow-hidden">
      <loader-view [show]="modalLoading"></loader-view>
      <div *ngIf="!modalLoading">
        <ng-container
          *ngIf="validateAdminProfile(); else analist_profile_title">
          <h3>{{ 'CONFIRM_REQUEST_STATUS_ADMIN' | i18n }}</h3>
        </ng-container>
        <ng-template #analist_profile_title>
          <h3>{{ 'CONFIRM_REQUEST_STATUS' | i18n }}</h3>
        </ng-template>
        <form>
          <div class="input-group">
            <label>
              <ng-container
                *ngIf="validateAdminProfile(); else analist_profile">
                Razón del cambio:
              </ng-container>
              <ng-template #analist_profile>
                Razón de la solicitud:
              </ng-template>
              <span class="tl span-required" title="CAMPO OBLIGATORIO">
                (*)</span
              >
            </label>
            <textarea
              name="comment"
              class="form-control"
              [maxLength]="800"
              [(ngModel)]="userComment"></textarea>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-success"
        [disabled]="!userComment"
        (click)="submitComment()">
        {{ 'BTN_LABEL_ACCEPT' | i18n }}
      </button>
      <button type="button" class="btn btn-default" (click)="closeModal()">
        {{ 'BTN_LABEL_NO_CANCELAR' | i18n }}
      </button>
    </div>
  </div>
</div>
<ng-template #customMessageTemplate>
  <p>{{ 'NO_SE_PUEDE_EDITAR_ESTADOS_EN_REVISION' | i18n }}</p>
  <a
    (click)="navigateToSolicitudes()"
    style="cursor: pointer; text-decoration: underline">
    {{ 'NO_SE_PUEDE_EDITAR_ESTADOS_EN_REVISION_BTN' | i18n }}
  </a>
</ng-template>
